module.exports = __webpack_public_path__ + "img/ent2.78027f86.png";